import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';
import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  MAT_LEGACY_TOOLTIP_SCROLL_STRATEGY as MAT_TOOLTIP_SCROLL_STRATEGY,
  MatLegacyTooltipModule,
} from '@angular/material/legacy-tooltip';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { ProductType } from '@shared/models/product-type';
import { FollowButtonAriaLabelPipe } from '@shared/pipes/follow-button.pipes';
import { PreferencesService } from '@shared/services/preferences.service';
import { TooltipPositionIndicatorDirective } from '@shared/shared/directives/tooltip-position-indicator.directive';
import { TogglePreferenceAction } from '@shared/store/preferences/actions';
import { EMPTY } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { FollowButton } from '../../models/card';
import { FollowIconsComponent } from '../follow-icons/follow-icons.component';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';

function matTooltipScrollStrategyFactory(overlay: Overlay): () => ScrollStrategy {
  return () => overlay.scrollStrategies.close({ threshold: 0 });
}

@Component({
  selector: 'ten-follow-button',
  templateUrl: './follow-button.component.html',
  styleUrls: ['./follow-button.component.scss'],
  providers: [
    {
      provide: MAT_TOOLTIP_SCROLL_STRATEGY,
      deps: [Overlay],
      useFactory: matTooltipScrollStrategyFactory,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgIf,
    TranslateModule,
    TooltipPositionIndicatorDirective,
    MatLegacyTooltipModule,
    NgClass,
    FollowIconsComponent,
    FollowButtonAriaLabelPipe,
    AccessibleClickDirective,
  ],
})
export class FollowButtonComponent implements OnChanges {
  @Input() public followButtonData: FollowButton;
  @Output() public preferenceChange = new EventEmitter<boolean>();

  public isInsideCard: boolean;

  private isDisabled: boolean;
  public isActive: boolean;

  constructor(
    // @Optional() card: CardComponent,
    private preferenceService: PreferencesService,
    private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    // TODO: fix this
    // this.isInsideCard = !!card;
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.followButtonData && this.followButtonData) {
      this.isActive = this.followButtonData.preferred;
    }
  }

  public togglePreference(event: Event) {
    event.stopImmediatePropagation();
    event.stopPropagation();
    event.preventDefault();

    if (this.isDisabled) {
      return;
    }
    this.isDisabled = true;

    this.preferenceService
      .togglePreference(
        this.followButtonData.product.id,
        this.followButtonData.preferenceTracking,
        this.followButtonData.product.type,
        this.isActive,
        this.followButtonData.product.name,
        this.followButtonData.notificationTexts
      )
      .pipe(
        finalize(() => (this.isDisabled = false)),
        catchError(() => EMPTY)
      )
      .subscribe(() => {
        this.isActive = !this.isActive;
        this.preferenceChange.emit(this.isActive);
        this.changeDetectorRef.detectChanges();
        let itemId = null;
        if ([ProductType.Brand, ProductType.EntertainmentEvent].includes(this.followButtonData.product.type)) {
          itemId = `${this.followButtonData.product.id}-${this.followButtonData.product.type}`;
        }
        this.store.dispatch(new TogglePreferenceAction(itemId || this.followButtonData.product.id.toString()));
      });
  }
}
